import {useState, useRef} from "react";
import {useDispatch} from "react-redux";
import {withTranslation} from "react-i18next";
import {useTranslation} from "react-i18next";
import "./index.scss";

import {UserOutlined} from "@ant-design/icons";
import {Button, Form, Input, Alert} from "antd";
import NavbarNoLogin from "../../components/Header/Navbars/NavbarNoLogin";
import {xcService} from "../../_services/xcService";
import ReCAPTCHA from "react-google-recaptcha"
import { noCaptcha } from "_config";

const { TextArea } = Input;

function ContactPage(props) {
    const dispatch = useDispatch();
    const {t, i18n} = useTranslation();
    const captchaRef = useRef(null)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const onFinish = async (values) => {
        if (noCaptcha) {
            setErrorMsg("");
            setLoading(true);
            setSuccess(true);
            setError(false);
            return;
        }

        const token = captchaRef.current.getValue();
        let payload = values;
        payload.token = token
        setError(false);
        setErrorMsg("");
        setLoading(true);
        setSuccess(false);

        xcService.post("/v1/contactform", payload).then(res => {
            setLoading(false)
            captchaRef.current.reset();
            if (res.data.success) {
                setSuccess(true);
                setError(false);
            } else {
                setError(true);
                setErrorMsg("captcha");
            }

        })
            .catch((error) => {
                setLoading(false)
                captchaRef.current.reset();
            })


    };

    return (
        <>
            <div className={"headerNoRegister home"}>
                <NavbarNoLogin className="menuNavHome"/>

                <div className={"containerDesc boxed"}>
                    <div className={"subHeaderNoRegister"} style={{margin: "auto"}}>
                        <div style={{padding: 15}}>
                        <h3>{t("contact.ini")}</h3>
                        <h4>{t("contact.subini")}</h4>
                        <Form
                            name="normal_login"
                            className="authForm allHeightMobile"
                            layout="vertical"
                            labelCol={{span: 22}}
                            wrapperCol={{span: 22}}
                            initialValues={{
                                remember: true,
                            }}
                            onFinish={onFinish}
                        >


                            <div style={{marginTop: 16}}></div>
                            <Form.Item
                                label={t("login.name")}
                                name="name"
                                style={{marginBottom: 8}}
                            >
                                <Input
                                    placeholder={t("contact.nombre")}
                                />
                            </Form.Item>
                            <Form.Item
                                label={t("login.email")}
                                name="email"
                                rules={[
                                    {
                                        type: "email",
                                        message: t("login.emailIncorrect"),
                                    },
                                    {
                                        required: true,
                                        message: t("login.emailMandatory"),
                                    },
                                ]}
                            >
                                <Input
                                    prefix={<UserOutlined className="site-form-item-icon colorBlue"/>}
                                    placeholder={t("login.emailp")}
                                />
                            </Form.Item>

                            <Form.Item
                                label={t("tutores.informes.tabletelephone")}
                                name="phone"
                                style={{marginBottom: 8}}
                            >
                                <Input
                                    placeholder={"XXX XXX XXX"}
                                />
                            </Form.Item>
                            <Form.Item
                                label={t("contact.mensaje")}
                                name="comment"
                                rules={[

                                    {
                                        required: true,
                                        message: t("contact.mensajed"),
                                    },
                                ]}
                            >
                                <TextArea
                                    rows={3}
                                    placeholder={t("contact.mensajep")}
                                />
                            </Form.Item>
                            { !noCaptcha &&
                            <ReCAPTCHA ref={captchaRef}
                                       sitekey={process.env.REACT_APP_SITE_KEY}
                            />
                            }
                            <Form.Item>
                                <Button
                                    loading={loading}
                                    htmlType="submit"
                                    className="primaryButton buttonSizeXL"
                                    type="primary"
                                >
                                    {t("contact.enviar")}
                                </Button>
                                {success && <Alert message={t("contact.enviadoa")} type="success"/>}
                                {error && <Alert message={errorMsg} type="error"/>}
                            </Form.Item>
                        </Form>
                        </div>
                    </div>
                </div>
            </div>

        </>)
}

export default withTranslation()(ContactPage);
